import type { Listing } from '@thevillages/schemas';

import type { ListingsService } from '../listings';

export function Reps(this: ListingsService, listing: Listing, currentValue: boolean): boolean {
  // If no value is set, do not affect the filter.
  if (this.filteringService.reps().length < 1) {
    return currentValue;
  }

  // If the listing does not have a value, exclude it from results.
  if (!listing.model?.id) {
    return false;
  }

  // Determine if the listing matches the filter.
  const _listingsReps = listing.listingReps.map((rep: { id: number }) => rep.id || 0);

  if (
    _listingsReps.length < 1 ||
    !_listingsReps.some((repId: number) => this.filteringService.reps().includes(repId.toString()))
  ) {
    return false;
  }

  // If the listing does not match the filter, do not affect the filter.
  return currentValue;
}
